import React from "react";

// components

import MapExample from "components/Maps/MapExample.js";

export default function Maps() {
  return (
    <>
      <div className="flex z-20">
        <div className="w-full px-4">
        <iframe width="100%" height="800" style={{'z-index':"999999",'marginTop':"200px"}} src="https://pancakeswap.finance/swap?outputCurrency=0x6364c250a26f171e05b9D26b66baB17921eC72b9" title="Flooz Trade" frameborder="0" allow="clipboard-read; clipboard-write; web-share; accelerometer *; autoplay *; camera *; gyroscope *; payment *"> </iframe>
  
        </div>
      </div>
    </>
  );
}
